import { useFirestore } from "hooks/firestore/v2/useFirestore";
import { bettingEventStatus } from "hooks/firestore/v2/models/bettingEventStatus";

const useBettingEventStatuses = (eventId: string) => {
  const { data, isLoading, error } = useFirestore(
    `/bettingEventStatuses/${eventId}`,
    bettingEventStatus,
  );

  return {
    bettingEventStatus: data,
    isLoading,
    error,
  };
};

type BettingEventStatus = Exclude<
  ReturnType<typeof useBettingEventStatuses>["bettingEventStatus"],
  undefined
>;

export { useBettingEventStatuses, type BettingEventStatus };
